<template>
    <div>
        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
            <el-table-column
                    prop="departmentName"
                    label="部门名称"
                    width="240">
            </el-table-column>
            <el-table-column
                    prop="status"
                    label="状态"
                    width="120">
                <template slot-scope="scope">
                    <span v-html="previewType(scope.row.previewType)"></span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="feedback"
                    label="部门意见">
                <template slot-scope="scope">
                    <span>{{scope.row.feedbackContent }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>

    import {previewList} from "../../../api/admin/sysMaterialPreview/index";

    export default {
        components: {
        },
        watch: {
        },
        props:["id"],
        computed:{
        },
        created(){
            this.loadDepartmentTree();
        },
        mounted(){
            this.loadDepartmentTree();
        },
        data() {
            return {
                tableData: [],
                form:{

                }
            };
        },
        methods:{
            previewType:function(previewType){
              if(previewType==1){
                  return "<span style='color:#03cb78;'>无意见</span>"
              }else if(previewType==2){
                  return "<span style='color:red;'>需整改</span>"
              }
              return "未审阅";
            },
            loadDepartmentTree:function(){
                previewList(this.id).then(data => {
                    this.tableData = data
                })
            },
        }
    };
</script>
